import { orderStatus as statusConstants } from '../../../../../../utils/constant';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const {
  pendingValidation,
  waitingOnSales,
  waitingOnCredit,
  contractSigned,
  contractSent,
  orderPlaced,
  orderActivated,
  orderShipped,
  orderCompleted
} = statusConstants;

const statusOptions = [
  {
    value: waitingOnSales,
    availableForStatus: [pendingValidation, waitingOnCredit]
  },
  {
    value: waitingOnCredit,
    availableForStatus: [pendingValidation, waitingOnCredit]
  },
  {
    value: contractSent,
    availableForStatus: [pendingValidation, waitingOnCredit, contractSent]
  },
  {
    value: orderPlaced,
    availableForStatus: [
      pendingValidation,
      waitingOnCredit,
      contractSent,
      contractSigned,
      orderPlaced,
      orderShipped,
      orderActivated,
      orderCompleted
    ]
  },
  {
    value: orderActivated,
    availableForStatus: [
      pendingValidation,
      waitingOnCredit,
      contractSent,
      contractSigned,
      orderPlaced,
      orderShipped,
      orderActivated,
      orderCompleted
    ]
  },
  {
    value: orderShipped,
    availableForStatus: [
      pendingValidation,
      waitingOnCredit,
      contractSent,
      contractSigned,
      orderPlaced,
      orderShipped,
      orderActivated,
      orderCompleted
    ]
  },
  {
    value: orderCompleted,
    availableForStatus: [
      pendingValidation,
      waitingOnCredit,
      contractSent,
      contractSigned,
      orderPlaced,
      orderShipped,
      orderActivated,
      orderCompleted
    ]
  }
];

const getStatusOptions = orderData => {
  const { status: orderStatus, iotAccountType } = orderData;
  const {
    iotOrderDetailsSection: { statusActions },
    contentfulValues: { valueCorporate }
  } = useLocalizedStringsContext();
  const options = [];

  statusOptions.forEach(option => {
    if (
      !(
        !option.availableForStatus.includes(orderStatus) ||
        (iotAccountType === valueCorporate && option.value === contractSent)
      )
    )
      options.push({
        text: statusActions[option.value],
        value: option.value
      });
  });
  return options;
};

export default getStatusOptions;
